import * as React from 'react';

import { routes } from 'config/routes';
import { FormReviewPivotTableContextProvider } from 'stores/local';

import { useFormReviewPage } from '../context';

import { Content } from './Content';

export const FormReviewPivotTable: React.FC = () => {
  const { setRoute } = useFormReviewPage();

  React.useEffect(() => {
    setRoute(routes.form.createPath());
  }, [setRoute]);

  return (
    <FormReviewPivotTableContextProvider>
      <Content />
    </FormReviewPivotTableContextProvider>
  );
};

export default FormReviewPivotTable;
